module.exports = __webpack_public_path__ + "static/media/submissionSuccessNotSatisfied.18d58d18.svg";